import React, { memo } from 'react'
import { CommonPopup } from 'common/components/entities/popup-new'
import { useActions } from 'common/hooks/useActions'
import { PopupInterface } from 'common/types/entities/popup-interface'
import * as actions from 'client/actions/actionsManagement'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import useManagement from 'client/hooks/useManagement'
import { selectors } from 'client/reducers/managementReducer'
import { PopupEditButton } from './ui/popup-edit-button'
import { PopupOverlayUi } from './ui/popup-overlay-ui'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'

interface PopupProps {
  entity: PopupInterface
  hidePopupEditButton?: boolean
}

const PopupNew = ({ entity, hidePopupEditButton }: PopupProps) => {
  const { isMobile } = useDeviceModeContext()

  const toggleSettings = useActions(actions.toggleSettings)
  const isSomethingEditing = useManagement(selectors.isSomethingEditing)
  const openSettings = () => toggleSettings(entity.id)
  const closeSettings = () => toggleSettings(null)
  const { background } = useThemeColor()
  const globalPopupBackgroundColor = background?.popupBackgroundColor
  return (
    <React.Fragment>
      {!hidePopupEditButton && <PopupEditButton clickHandler={openSettings} />}
      <CommonPopup
        onCloseHandler={() => {}}
        showClose={!!+entity.showClose}
        maxHeight={isMobile ? '500px' : 'calc(100vh - 110px)'}
        entity={entity}
        backgroundColor={entity.background || globalPopupBackgroundColor}
        mobileBackgroundColor={
          entity.mobileBackground || globalPopupBackgroundColor
        }
      >
        <ChildrenEntities
          id={entity.id}
          type={entity.type}
          childIds={entity.childIds}
        />
      </CommonPopup>
      <PopupOverlayUi
        zIndex={isSomethingEditing ? 1 : -1}
        onClick={closeSettings}
      />
    </React.Fragment>
  )
}


export default memo(PopupNew)
